import { h } from "preact";
import "./Line.scss";

export const Line = ({ className }: { className?: string }) => <hr className={`line nl3 ${className ?? ""}`} />;
